import { render } from "./approveBooking.vue?vue&type=template&id=46c0bcbc&scoped=true"
import script from "./approveBooking.vue?vue&type=script&lang=js"
export * from "./approveBooking.vue?vue&type=script&lang=js"

import "./approveBooking.vue?vue&type=style&index=0&id=46c0bcbc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c0bcbc"]])

export default __exports__